import type { Shape } from "../../../entities/_base/Shape";
import type { ShapeEditingService } from "../../../services/ShapeEditingService";

abstract class ShapeTool<TShape extends Shape> {
	/** Drawing tools enable cursor snapping while active (see ITool.snapsWhileActive). */
	public readonly snapsWhileActive: boolean = true;

	protected currentShape: TShape | null = null;
	protected shapes: Array<TShape> = [];

	constructor(protected readonly shapeEditingService: ShapeEditingService) {}

	protected onShapeAccepted(_shape: TShape): void {}

	/**
	 * Drops a disposed shape from the tool's list. `shapes` is iterated on every store change (see
	 * applyLabelsVisibility), and resyncing a disposed shape rebuilds its view — including fresh
	 * vertex handles attached to a group that is no longer in the scene.
	 */
	protected forgetShape(shape: TShape): void {
		const index = this.shapes.indexOf(shape);

		if (index !== -1) {
			this.shapes.splice(index, 1);
		}
	}

	protected abstract createShape(): TShape;

	public cancelDrawing(): void {
		this.discardCurrentShape();
	}

	protected discardCurrentShape(): void {
		this.currentShape?.dispose();
		this.currentShape = null;
	}

	protected acceptCurrentShape(): void {
		if (this.currentShape === null) {
			return;
		}

		this.shapeEditingService.registerShape(this.currentShape);

		this.currentShape.finish();
		this.onShapeAccepted(this.currentShape);
		this.currentShape = null;
	}
}

export { ShapeTool };
